var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcludeDatesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 7.2999H6.90005C6.30005 7.2999 5.80005 6.7999 5.80005 6.1999V2.4999C5.80005 1.8999 6.30005 1.3999 6.90005 1.3999H7.00005C7.60005 1.3999 8.10005 1.8999 8.10005 2.4999V6.1999C8.10005 6.7999 7.60005 7.2999 7.00005 7.2999Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 7.2999H14.7001C14.1001 7.2999 13.6001 6.7999 13.6001 6.1999V2.4999C13.6001 1.8999 14.1001 1.3999 14.7001 1.3999H14.9001C15.5001 1.3999 16.0001 1.8999 16.0001 2.4999V6.1999C16.0001 6.7999 15.5001 7.2999 14.9001 7.2999Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 23.1001H2.7C1.8 23.1001 1 22.3001 1 21.4001V6.3001C1 5.4001 1.8 4.6001 2.7 4.6001H19.1C20 4.6001 20.8 5.4001 20.8 6.3001V21.4001C20.8 22.4001 20 23.1001 19.1 23.1001Z",
    stroke: "#231F20",
    strokeWidth: 1.9486,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 11.6001C6.75224 11.6001 7.19995 11.1524 7.19995 10.6001C7.19995 10.0478 6.75224 9.6001 6.19995 9.6001C5.64767 9.6001 5.19995 10.0478 5.19995 10.6001C5.19995 11.1524 5.64767 11.6001 6.19995 11.6001Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8999 11.6001C11.4522 11.6001 11.8999 11.1524 11.8999 10.6001C11.8999 10.0478 11.4522 9.6001 10.8999 9.6001C10.3476 9.6001 9.8999 10.0478 9.8999 10.6001C9.8999 11.1524 10.3476 11.6001 10.8999 11.6001Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 11.6001C16.1521 11.6001 16.5999 11.1524 16.5999 10.6001C16.5999 10.0478 16.1521 9.6001 15.5999 9.6001C15.0476 9.6001 14.5999 10.0478 14.5999 10.6001C14.5999 11.1524 15.0476 11.6001 15.5999 11.6001Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 15.5C6.75224 15.5 7.19995 15.0523 7.19995 14.5C7.19995 13.9477 6.75224 13.5 6.19995 13.5C5.64767 13.5 5.19995 13.9477 5.19995 14.5C5.19995 15.0523 5.64767 15.5 6.19995 15.5Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8999 15.5C11.4522 15.5 11.8999 15.0523 11.8999 14.5C11.8999 13.9477 11.4522 13.5 10.8999 13.5C10.3476 13.5 9.8999 13.9477 9.8999 14.5C9.8999 15.0523 10.3476 15.5 10.8999 15.5Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 15.5C16.1521 15.5 16.5999 15.0523 16.5999 14.5C16.5999 13.9477 16.1521 13.5 15.5999 13.5C15.0476 13.5 14.5999 13.9477 14.5999 14.5C14.5999 15.0523 15.0476 15.5 15.5999 15.5Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19995 19.3999C6.75224 19.3999 7.19995 18.9522 7.19995 18.3999C7.19995 17.8476 6.75224 17.3999 6.19995 17.3999C5.64767 17.3999 5.19995 17.8476 5.19995 18.3999C5.19995 18.9522 5.64767 19.3999 6.19995 19.3999Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8999 19.3999C11.4522 19.3999 11.8999 18.9522 11.8999 18.3999C11.8999 17.8476 11.4522 17.3999 10.8999 17.3999C10.3476 17.3999 9.8999 17.8476 9.8999 18.3999C9.8999 18.9522 10.3476 19.3999 10.8999 19.3999Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 19.3999C16.1521 19.3999 16.5999 18.9522 16.5999 18.3999C16.5999 17.8476 16.1521 17.3999 15.5999 17.3999C15.0476 17.3999 14.5999 17.8476 14.5999 18.3999C14.5999 18.9522 15.0476 19.3999 15.5999 19.3999Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C25.8137 12 28.5 9.31371 28.5 6C28.5 2.68629 25.8137 0 22.5 0C19.1863 0 16.5 2.68629 16.5 6C16.5 9.31371 19.1863 12 22.5 12Z",
    fill: "#EC2227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 4.3001L20.9002 8.4001C20.7002 8.6001 20.3002 8.6001 20.1002 8.4001C19.9002 8.2001 19.9002 7.8001 20.1002 7.6001L24.2002 3.5001C24.4002 3.3001 24.8002 3.3001 25.0002 3.5001C25.2002 3.7001 25.2002 4.1001 25.0002 4.3001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2001 8.4001L20.0001 4.3001C19.8001 4.1001 19.8001 3.7001 20.0001 3.5001C20.2001 3.3001 20.6001 3.3001 20.8001 3.5001L25.0001 7.6001C25.2001 7.8001 25.2001 8.2001 25.0001 8.4001C24.7001 8.6001 24.4001 8.6001 24.2001 8.4001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.5,
    height: 24.1,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcludeDatesIcon);
export default __webpack_public_path__ + "static/media/exclude-dates-icon.f7290b68.svg";
export { ForwardRef as ReactComponent };